module.exports = __webpack_public_path__ + "static/32214925_1015375681954514_8316080609554333696_n-faaaf6a6e66b08736051b812efbc47ca.jpg";